import './number.scss';

const counters = document.querySelectorAll('.value');
const speed = 200;

let formatter = new Intl.NumberFormat('it-IT');

const animateCounter = (counter) => {
    const value = +counter.getAttribute('finalNumber');
    const data = +counter.innerText;

    const time = value / speed;
    if (data < value) {
        counter.innerText = Math.ceil(data + time);
        setTimeout(() => animateCounter(counter), 1);
    } else {
        counter.innerText = formatter.format( value );
    }
};

const observerOptions = {
    threshold: 0.5
};

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.querySelectorAll('.value').forEach(counter => {
                animateCounter(counter);
            });
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

const sections = document.querySelectorAll('.number-card');

sections.forEach(section => {
    observer.observe(section);
});



const number = () => {}

export default number;